<template>
  <button
    id="id-location-request-btn"
    type="button"
    class="btn btn-rounded btn-light btn-block"
    :disabled="!generalConditionForCTA"
    @click.prevent="locationRequest()"
  >
    Location Rebid
  </button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    sessionId: String,
    conversationId: String
  },
  computed: {
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters("agency", ["agencySettings"]),
    ...mapGetters("conversations", ["currentConversation"]),
    generalConditionForCTA() {
      const { status, operator_id } = this.currentConversation;
      const { enableConversationAssignment } = this.agencySettings;

      if (status === "active") {
        if (enableConversationAssignment === false) {
          return true;
        }
        if (enableConversationAssignment === true && (operator_id === this.currentUser.user_id || (operator_id !== null && this.$permission("admin:agency")))) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    async locationRequest() {
      if (confirm("Rebid location request for this recipient?")) {
        await this.$ConveyApi.tccApi.rebidTccSessionLocation({ sessionId: this.sessionId });
      }
    }
  },
};
</script>
